import React from 'react';
import { Form } from 'react-bootstrap';

const LinkedProjectSelector = ({
  linkedProjects,
  selectedProjectId,
  onProjectChange,
}) => {
  const handleChange = (event) => {
    const selectedId = event.target.value;
    const selected = linkedProjects.find(
      (p) => p.linked_project_id === selectedId
    );
    onProjectChange(selected);
  };

  const truncate = (text, maxLength = 25) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  return (
    <Form.Select
      value={selectedProjectId || ''}
      onChange={handleChange}
      aria-required="true"
      style={{ maxWidth: '100%' }}
    >
      <option value="none" disabled>
        Select a JIRA project
      </option>
      {linkedProjects?.map((project) => (
        <option
          key={project.linked_project_id}
          value={project.linked_project_id}
          title={`${project.linked_project_key} - ${project.linked_project_name}`}
        >
          {project.linked_project_key} - {truncate(project.linked_project_name)}
        </option>
      ))}
    </Form.Select>
  );
};

export default LinkedProjectSelector;
